export const TRANSACTION_ID_HEADER = "X-Auvious-TransactionId";
export const CREATE_INTERNAL_SIGNED_URL_HEADER = "X-Auvious-CreateInternalSignedUrl";
